"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paths = void 0;
exports.paths = {
    discussions: 'discussions',
    appUserInvites: 'invites',
    appUsers: 'users',
    discussion: (discussionId) => `discussions/${discussionId}`,
    discussionSecrets: (discussionId, userId) => `discussions/${discussionId}/secrets/${userId}`,
    discussionMessages: (discussionId) => `discussions/${discussionId}/messages`,
    appUser: (userId) => `users/${userId}`,
    appUserInvite: (id) => `invites/${id}`,
};
//# sourceMappingURL=paths.js.map